export const DRAG_HANDLE_CONTAINER_HEIGHT = 24;
export const DRAG_HANDLE_CONTAINER_WIDTH = 16;
export const DRAG_HANDLE_CONTAINER_WIDTH_TOP_LEVEL = 8;
export const DRAG_HANDLE_CONTAINER_OFFSET_LEFT = 2;
export const DRAG_HANDLE_CONTAINER_OFFSET_LEFT_LIST = 18;
export const DRAG_HANDLE_CONTAINER_OFFSET_LEFT_TOP_LEVEL = 5;
export const DRAG_HANDLE_CONTAINER_PADDING = 8;

export const DRAG_HANDLE_GRABBER_HEIGHT = 12;
export const DRAG_HANDLE_GRABBER_WIDTH = 4;
export const DRAG_HANDLE_GRABBER_WIDTH_HOVERED = 2;
export const DRAG_HANDLE_GRABBER_BORDER_RADIUS = 4;
export const DRAG_HANDLE_GRABBER_MARGIN = 4;

export const HOVER_AREA_RECT_PADDING_TOP_LEVEL = 6;

export const NOTE_CONTAINER_PADDING = 24;
export const EDGELESS_NOTE_EXTRA_PADDING = 20;
export const DRAG_HOVER_RECT_PADDING = 4;

/**
 * Side by side drop zone. Dropping within this band of the target's left or
 * right border creates an `affine:columns` row instead of reordering.
 *
 * Atlaskit's `closest-edge` is unusable here — it picks the edge with the
 * smallest pixel distance, and for a full width paragraph the top/bottom edge
 * always wins, so the zone is measured from the pointer instead.
 */
export const COLUMN_DROP_ZONE_RATIO = 0.25;
export const COLUMN_DROP_ZONE_MIN_WIDTH = 32;
export const COLUMN_DROP_ZONE_MAX_WIDTH = 100;

/**
 * Band along the target's top and bottom borders that keeps meaning "insert
 * above / below". Without it a drop aimed at a horizontal border would turn
 * into a column as soon as it drifted near the left or right edge, and plain
 * reordering along the gutter would become impossible.
 */
export const COLUMN_DROP_ZONE_VERTICAL_RATIO = 0.3;
export const COLUMN_DROP_ZONE_MIN_VERTICAL_MARGIN = 6;
export const COLUMN_DROP_ZONE_MAX_VERTICAL_MARGIN = 24;

/** Half of the `gap` between columns, where the vertical indicator sits. */
export const COLUMN_DROP_INDICATOR_OFFSET = 12;
